import { net_api_url } from 'components/Store';
import axios from 'axios';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
const loadKeyWords = async (getAccessToken, source, includehidden) => {
  try {
    let token = await getAccessToken();
    let keyWordLists = await axios.get(
      `${net_api_url}/api/keyword-list/get-team-keyword-lists${includehidden ? '?includeHidden=true' : ''}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal: source?.signal,
      }
    );
    //CHECK ERRORS FROM THE KEYWORDS SCREEN
    let responseKeyWordLists = keyWordLists.data;
    responseKeyWordLists?.myKeywordLists?.forEach((item) => {
      item.isMyList = true;
    });

    let totalLists = responseKeyWordLists?.myKeywordLists?.concat(responseKeyWordLists.teamMemberKeywordLists);
    return totalLists;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.error(error?.config?.signal?.reason);
    } else {
      console.error(error);
    }
  }
};

const useLoadKeywordLists = () => {
  const { generalApiCall } = useGeneralApiCall();
  const loadKeywordsLists = async ({ source, includehidden, returnCompleteRequest }) => {
    try {
      const results = await generalApiCall({
        pathname: `/api/keyword-list/get-team-keyword-lists${includehidden ? '?includeHidden=true' : ''}`,
        method: 'get',
        notShowErrorMessage: true,
        needsAuthentication: true,
        returnCompleteRequest,
        requestSource: source,
      });
      return results;
    } catch (error) {}
  };
  const compileKeywordsLists = ({ keywordsLists }) => {
    let responseKeyWordLists = {
      ...keywordsLists,
      myKeywordLists: keywordsLists?.myKeywordLists?.map((item) => {
        return {
          ...item,
          isMyList: true,
        };
      }),
    };
    const totalLists = responseKeyWordLists?.myKeywordLists?.concat(responseKeyWordLists.teamMemberKeywordLists);
    return totalLists;
  };

  return { loadKeywordsLists, compileKeywordsLists };
};

const loadEmailAlerts = async (getAccessToken, source) => {
  try {
    let token = await getAccessToken();
    let emailLists = await axios.get(`${net_api_url}/api/alert-settings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal: source?.signal,
    });
    //CHECK ERRORS FROM THE KEYWORDS SCREEN
    return emailLists?.data;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.error(error?.config?.signal?.reason);
    } else {
      console.error(error);
    }
  }
};

export { useLoadKeywordLists };
export { loadKeyWords, loadEmailAlerts };
